import { Button, Paper, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";

const ReferralComponent = () => {
  const navigate = useNavigate();
  return (
    <Paper
      withBorder
      style={{
        backgroundImage: "linear-gradient(180deg, #003554 0%, #0582CA 100%)",
        borderColor: "#000"
      }}
      shadow="md"
      px={30}
      py={28}
      h={280}
    >
      <Title size={20} c={"white"}>
        Manta Classic Referral Program
      </Title>
      <Text fz={14} c={"white"} mt={10}>
        Earn <span style={{ fontWeight: "bold" }}>up to $500</span> when you refer
        a friend who joins with a paid subscription!
      </Text>
      <Button
        c={"#003554"}
        fw={"600"}
        fz={14}
        bg={"white"}
        h={40}
        px={30}
        bd={"1px solid #000"}
        mt={"90"}
        radius={"xl"}
        onClick={() => navigate("/referral-link")}
        style={{ boxShadow: "0px 4px 4px #00000020" }}
      >
        Refer a friend today!
      </Button>
    </Paper>
  );
};
export default ReferralComponent;
